var EPKCampaignAnswerProgress = EPKCampaignAnswerProgress || {};
var EPK = EPK || {};
EPK.Campaigns = function(){
};

EPK.Campaigns.prototype.currentInputForm = null;

EPK.Campaigns.prototype.initialize = function() {
	var _this = this;
	$(".btn-clear-shop").on("click",function(e){
		_this.clearShop(e);
	});

};

EPK.Campaigns.prototype.clearShop = function(e) {
	$target = $(e.target);
	var delete_url = $target.data("delete-url");
	$qblock = $target.closest(".q-block");

	$.ajax(
		{
			type: "GET",
			url: delete_url,
			cache: false,
			timeout: 20000,
		}
	);

	$qblock.find(".shop_id").val("");
	$qblock.find(".result-box").remove(0);
	$qblock.find(".upload-input").text("店舗を選択する");
};

EPK.Campaigns.prototype.saveTemporaryAnswer = function(e) {
	$form = $("#frm-question");

	$.ajax(
		{
			type: "POST",
			url: $form.prop("action"),
			data: $form.serializeArray(),
			cache: false,
			async: false,
			timeout: 20000,
		}
	);
};

//文字数カウンター
EPK.Campaigns.prototype.textCheck = function(event) {
	var $textarea = $(event.target);
	var $qblock = $textarea.closest(".q-block");
	var maxlength = $textarea.data("maxlength");
	var minlength = $textarea.data("minlength");
	var $count = $qblock.find(".form-textlength");
	var $countDownMin = $qblock.find('.form-countdown-min');
	var $countDownMax = $qblock.find('.form-countdown-max');

	var thisValueLength = $textarea.val().replace(/\s+/g,'').length;

	$count.text(thisValueLength);
	if(thisValueLength > 1000){
		$count.addClass('over-text');
	}else{
		$count.removeClass('over-text');
	}
	$countDownMin.text(Math.max((minlength)-(thisValueLength), 0));
	$countDownMax.text(Math.max((maxlength)-(thisValueLength), 0));
};

EPK.Campaigns.prototype.toggleOptionTextField = function() {
	if (typeof EPKCampaignAnswerProgress !== 'undefined'){
		if (typeof EPKCampaignAnswerProgress.option_text_pairs !== 'undefined'){
			Object.keys(EPKCampaignAnswerProgress.option_text_pairs).forEach(function (key) {
				var $_inputTag = $('#'+key);
				var $_optionTextBlock = $('#blk-'+key);
				var _isChecked = $_inputTag.is(':checked');
				if( _isChecked === true) {
					$_optionTextBlock.show();
				} else {
					$_optionTextBlock.hide();
				}
			});
		}
	}
};

// #9438 非同期化対応
function initMap() {
	if (EPK.mapArgs && typeof google !== "undefined") {
		var mapObj = EPK.shoplistMap(EPK.mapArgs);
	} else {
		// 準備ができていなかった場合のケア
		google.maps.event.addDomListener(window, 'load', initMap);
	}
}

$(function(){
	var campaigns = new EPK.Campaigns();
	$(".link-shop-select").on('click',function(event) {
		campaigns.saveTemporaryAnswer(event);
	});

	var $textarea = $('.mstore-textarea');
	$textarea.bind('keydown keyup keypress change paste',function(event) {
		campaigns.textCheck(event);
	});
	campaigns.initialize();
	campaigns.toggleOptionTextField();

	if (typeof EPKCampaignAnswerProgress !== 'undefined'){
		if (typeof EPKCampaignAnswerProgress.option_text_pairs !== 'undefined'){
			Object.keys(EPKCampaignAnswerProgress.option_text_pairs).forEach(function (key) {
				var $_inputTag = $('#'+key);
				var _inputName = $_inputTag.attr('name');
				$('input[name="'+_inputName+'"]').on('change',campaigns.toggleOptionTextField);
			});
		}
	}

	// SMSの二重送信を防ぐ
	var $sendSmsForm = $('#form-sms-send');
	$sendSmsForm.on('submit', function() {
		var self = this;
		$(":submit", self).prop("disabled", true);
		setTimeout(function() {
			$(":submit", self).prop("disabled", false);
		}, 10000);
	});

	// 抽選の二重送信を防ぐ
	var $sendLot = $('#frm-lot');
	$sendLot.on('submit', function() {
		var self = this;
		$(":submit", self).prop("disabled", true);
		setTimeout(function() {
			$(":submit", self).prop("disabled", false);
		}, 30000);
	});

	// アンケート回答の二重送信を防ぐ
	var $sendQuestion = $('#frm-question');
	$sendQuestion.on('submit', function() {
		var self = this;
		$("#submit").prop("disabled", true);
		$(":submit", self).prop("disabled", true);
		setTimeout(function() {
			$(":submit", self).prop("disabled", false);
		}, 10000);
	});

	// フォームの二重送信を防ぐ（汎用）
	var $frmGuarded = $('.frm-guard-duplicate-send');
	$frmGuarded.on('submit', function() {
		var self = this;
		$(":submit", self).prop("disabled", true);
	});

});
